import React, {Component} from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux';
import {Formik, Form, Field, ErrorMessage} from 'formik';
import * as Yup from 'yup';

import {CONFIG} from '../../config'
import {getBookingEngineTranslations} from "@assets/js/functions/helpers";

const translations = getBookingEngineTranslations();

import {
    setLoginData,
    setUser,
    validateOrder,
} from '../../actions/summaryActions';

class LoginForm extends Component {
    state = {
        id: null,
        isLogged: null,
        loginError: null
    }

    componentDidMount() {
        const {id} = this.props.user
    }


    logInUser = loginData => {
        const url = `${location.origin}${CONFIG.loginEndpoint}?`
        const {translations, setUser} = this.props

        fetch(url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(loginData)
        })
            .then(response => response.json())
            .then(res => {
                const resErrorMessage = !res.status ? res.message : null;

                this.setState({
                    loginError: resErrorMessage
                }, () => {
                    // console.log(res)
                    if (res.user) {
                        // TODO: why in state rather than store?
                        this.setState({id: res.user.id})
                        this.props.setUser(res.user)
                    }

                    this.props.validateOrder()
                })
            })
            .catch(error => {
                    alert(`${translations['error-message']} ${error}`)
                }
            )
    }

    render() {
        const {loginError} = this.state
        const {
            user,
            translations,
        } = this.props

        const SignupSchema = Yup.object().shape({
            email: Yup.string()
                .email('Invalid email')
                .required('To pole jest wymagane'),
            password: Yup.string()
                .required('To pole jest wymagane'),
        });

        const InputWithIcon = ({
                                   field,
                                   form: {touched, errors},
                                   ...props
                               }) => (
            <div
                className={`form-field--custom`}
                data-tooltip={translations['form_field-invalid']}
            >
                <img src={props.icon} alt='VacationClub' className='form-field__icon'/>
                <input
                    className={`form-field 
                            ${touched[field.name] && errors[field.name] ? 'form-field--invalid' : ''}
                            ${props.icon && 'form-field--with-icon'}
                            `}
                    type="text" {...field} {...props} />

                {
                    touched[field.name] && errors[field.name] &&
                    <span className='form-field--invalid-label'>{translations['form_field-invalid']}</span>
                }
            </div>
        )

        return (
            <div className="user_box user_box--login">
                {!user.id ?
                    <div>
                        <Formik
                            initialValues={{
                                email: '',
                                password: '',
                            }}
                            validationSchema={SignupSchema}
                            onSubmit={values => {
                                this.logInUser({
                                    login: values.email,
                                    password: values.password
                                })
                            }}
                        >
                            {({errors, touched}) => (
                                <Form>
                                    {loginError &&
                                    <div className="alert alert-error">{translations['login-error']}</div>}
                                    <Field
                                        name="email"
                                        placeholder={translations['placeholder-login-email']}
                                        icon='/img/icons/icon-envelope.svg'
                                        component={InputWithIcon}
                                        data-tooltip={translations['form_field-invalid']}
                                    />
                                    <Field
                                        name="password"
                                        type="password"
                                        placeholder={translations['placeholder-login-password']}
                                        icon='/img/icons/icon-key.svg'
                                        component={InputWithIcon}
                                        data-tooltip={translations['form_field-invalid']}
                                    />

                                    <div className="user_box__actions">
                                        <div className="user_box__actions__column user_box__actions--left">
                                            <button
                                                className="btn_vc btn_vc--autowidth btn_vc--turquoise"
                                                type="submit"
                                            >{translations['user-data-login']}</button>
                                        </div>
                                        <div className="user_box__actions__column user_box__actions--right">
                                            <div className="user_box__actions__column__forgot_password">
                                                <div className="user_box__actions__column__forgot_password__icon">
                                                    <img src="/img/icons/icon-lock.svg" alt="security icon"/>
                                                </div>
                                                <div className="user_box__actions__column__forgot_password__text">
                                                    <a href={location.origin + CONFIG.changeUserPasswordUrl}
                                                       target="_blank">
                                                        {translations['user-data-remember']}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                        <div className="user_box__regulations">
                            {translations['privacy-policy-1']}
                            {' '}
                            <a href={translations['booking-terms-href']}
                               target="_blank">{translations['booking-terms-name']}</a>,
                            {' '}
                            <a href={translations['regulations-href']}
                               target="_blank">{translations['regulations-name']}</a>,
                            {' '}
                            <a href={translations['regulations-of-services-electronic-href']}
                               target="_blank">{translations['regulations-of-services-electronic-name']}</a>
                            {' '}
                            {translations['privacy-policy-3']}
                            {' '}
                            <a href={translations['privacy-policy-href']}
                               target="_blank">{translations['privacy-policy-name']}</a>.
                        </div>
                    </div>
                    :
                    <div>
                        {this.props.children}
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { login_form, user: { id }, user } = state.summary;

    return {
        loginFormFields: login_form,
        user,
        id,
        translations: state.translations
    }
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            setLoginData,
            setUser,
            validateOrder,
        },
        dispatch
    )

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LoginForm)

